<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-24"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title class="cancel-width my-margin-bottom">
        <label slot="title">{{ $t("label.system.tenant.detail.tenant") }}</label>
        <lvory-but
          v-show="this.$IsShowButFun('010604', deleteFlag, !defaultFlag)"
          @click="deleteTenant"
          slot="cancel">
          {{ $t("button.common.data.delete") }}
        </lvory-but>
        <narrow-down
          v-show="this.$IsShowButFun('010603', deleteFlag, true)"
          @click="editTenant"
          slot="create">
          {{ $t("button.system.building.detail.edit") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.tenant.detail.label") }}
      </div>
      <!--  フォーム 開始  -->
      <el-row class="my-margin-bottom">
        <el-col>
          <el-form
            label-width="200px"
            label-position="left"
            :model="tenantInfo.tenantDetail"
            class="el-form-main">

            <el-row class="form-group display-line-box">
              <div class="left-div-type m-right-2">

                <div class="form-group-start">
                  <!-- 所属情報 -->
                  <div class="color width-134">
                    {{ $t("label.system.meetingRoom.detail.detailList") }}
                  </div>

                  <div>

                    <!--  オーナーID  -->
                    <el-form-item
                      size="small"
                      label-width="200px"
                      :label="$t('label.system.tenant.detail.ownerId')">
                      <div class="div-size text-word-break c-ivory01">
                        {{ this.tenantInfo.tenantDetail.ownerExId }}
                      </div>
                    </el-form-item>

                    <!--  オーナー名  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.ownerName')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.ownerName }}
                      </div>
                    </el-form-item>

                    <!--  テナントID  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.tenantExId')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.exId }}
                      </div>
                    </el-form-item>

                    <!--  テナント名  -->
                    <el-form-item
                      size="small"
                      label-width="200px"
                      :label="$t('label.system.tenant.detail.tenantName')">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.name }}
                      </div>
                    </el-form-item>
                  </div>
                </div>

                <hr class="delimiter" />

                <div class="form-group-start">
                  <!--  責任者情報部分 開始  -->
                  <div class="color width-134">
                    {{ $t("label.system.owner.edit.responsibleInformation") }}
                  </div>
                  <div>
                    <!--  氏名  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.resUserName')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.resUserName }}
                      </div>
                    </el-form-item>

                    <!--  電話番号  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.respUserTel')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.resUserTelNo }}
                      </div>
                    </el-form-item>

                    <!--  メールアドレス  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.respUserEmail')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.resUserEmail }}
                      </div>
                    </el-form-item>
                  </div>
                </div>

                <hr class="delimiter" />

                <div class="form-group-start">
                  <!--  本社情報 開始  -->
                  <div class="color width-134">
                    {{ $t("label.system.tenant.detail.company") }}
                  </div>
                  <div>
                    <!--  住所  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.adress')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.companyAddress }}
                      </div>
                    </el-form-item>

                    <!--  電話番号  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.companyTelNo')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.companyTelNo }}
                      </div>
                    </el-form-item>

                    <!--  サービス開通日時  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.serviceStartDate')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.serviceStartDate }}
                      </div>
                    </el-form-item>

                    <!--  サービス停止日時  -->
                    <el-form-item
                      :label="$t('label.system.tenant.detail.serviceEndDate')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.serviceEndDate }}
                      </div>
                    </el-form-item>

                     <!--  備考  -->
                     <el-form-item
                      :label="$t('label.system.tenant.detail.remarks')"
                      size="small"
                      label-width="200px">
                      <div class="div-size c-ivory01 text-word-break">
                        {{ this.tenantInfo.tenantDetail.remarks }}
                      </div>
                    </el-form-item>
                  </div>
                </div>

              </div>

              <div align="center" class="right-div-type">
                <div>
                  <sp-smart-button
                  v-show="(this.$IsShowButFun('010619', deleteFlag, !defaultFlag) || this.$IsShowButFun('010620', deleteFlag, !defaultFlag)) && tenantInfo.tenantDetail.outlookSyncFlag"
                  @click="outlookPortable"
                  class="buttom-size">
                    {{ $t("label.ownerSetting.outlookPortable") }}
                  </sp-smart-button>
                </div>

                <div>
                  <sp-smart-button
                  v-show="this.$IsShowButFun('010610', deleteFlag, !defaultFlag) && !tenantInfo.tenantDetail.outlookSyncFlag"
                  @click="linkCalendarPage"
                  class="buttom-size">
                    カレンダー連携設定編集
                  </sp-smart-button>
                </div>

                <sp-smart-button
                  v-show="this.$IsShowButFun('010801', deleteFlag, !defaultFlag)"
                  @click="searchAddressBook"
                  class="buttom-size">
                  {{ $t("label.system.tenant.detail.addressBook") }}
                </sp-smart-button>

                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010605', deleteFlag, !defaultFlag)"
                    @click="importUser"
                    class="buttom-size">
                    {{ $t("label.system.tenant.detail.userImport") }}
                  </sp-smart-button>
                </div>

                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010606', deleteFlag, !defaultFlag)"
                    @click="userDataCsv"
                    class="buttom-size">
                    {{ $t("label.system.tenant.detail.userDataCsv") }}
                  </sp-smart-button>
                </div>

                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010609', deleteFlag, !defaultFlag)"
                    @click="editUserArea"
                    class="buttom-size">
                    {{ $t("label.system.tenant.detail.userAreaEdit") }}
                  </sp-smart-button>
                </div>
                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$authListCheck('080401', '080210') && !tenantInfo.tenantDetail.outlookSyncFlag"
                    @click="packManage"
                    class="buttom-size">
                    パック管理
                  </sp-smart-button>
                </div>
                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$authListCheck('080310', '080210') && !tenantInfo.tenantDetail.outlookSyncFlag"
                    @click="PackDistributionSettings"
                    class="buttom-size">
                    パック配布設定
                  </sp-smart-button>
                </div>
                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010612', deleteFlag, !defaultFlag) && ssoBtnIsShow"
                    @click="linkSsoDetail"
                    class="buttom-size">
                    SSO連携情報
                  </sp-smart-button>
                </div>
                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010614', deleteFlag, !defaultFlag) && resourceBtnIsShow && !tenantInfo.tenantDetail.outlookSyncFlag"
                    @click="resourceEdit"
                    class="buttom-size">
                    リソース連携設定編集
                  </sp-smart-button>
                </div>
                <!-- ph3 lot3 カレンダー連携設定
                <div class="button-margin">
                  <sp-smart-button
                    v-show="this.$IsShowButFun('010610', deleteFlag, !defaultFlag)"
                    @click="linkCalendarPage"
                    class="buttom-size">
                    カレンダー連携設定
                  </sp-smart-button>
                </div> -->

                <!-- <div class="img-positions c-ivory01">
                  {{ $t("label.system.building.detail.img") }}
                </div> -->
                <!--  マップ  -->
                <!-- <div class="image-top">
                  <smart-office-auth-image
                    class="image-size"
                    :src="tenantInfo.tenantDetail.img.url">
                  </smart-office-auth-image>
                </div> -->
              </div>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <!--  フォーム 終了  -->

      <hr class="delimiter margin-top-0" />

      <!--  使用ビル  -->
      <div class="form-group m-bottom-5">
        <div class="word-div c-ivory01">
          使用ビル
        </div>
      </div>
      <el-table
        class="m-bottom-5 table-header-th-top-0"
        style="width: 100% !important"
        :data="tenantInfo.tenantDetail.accountCountLimitList">

        <!--  ビルID  -->
        <el-table-column
          class-name="col-2"
          prop="buildingExId"
          :label="$t('label.system.tenant.detail.buildingExId')">
        </el-table-column>

        <!--  ビル名  -->
        <el-table-column
          class-name="col-2"
          prop="buildingName"
          :label="$t('label.system.tenant.detail.buildingName')">
        </el-table-column>

        <!--  住所  -->
        <el-table-column
          class-name="col-4"
          prop="address"
          label="住所">
        </el-table-column>

        <!--  使用アカウント数  -->
        <el-table-column
          class-name="col-2"
          prop="accountCount"
          label="使用アカウント数">
        </el-table-column>

        <!--  アカウント上限数  -->
        <el-table-column
          class-name="col-3"
          prop="accountCountLimit"
          label="アカウント上限数">
          <template slot-scope="scope">
            <div v-if="scope.row.accountCountLimit == -1">
              ビル全体で共有
            </div>
            <div v-else>
              {{ scope.row.accountCountLimit }}
            </div>
          </template>
        </el-table-column>

      </el-table>

      <!--  借入エリア情報  -->
      <div class="form-group m-bottom-5">
        <div class="word-div c-ivory01">
          {{ $t("label.system.tenant.detail.areaDetail") }}
        </div>
        <div class="edit-button-div">
          <lvory-but
            @click="appendRelateArea"
            slot="create"
            v-show="this.$IsShowButFun('010607', deleteFlag, true)"
            class="Operat">
            {{ $t("label.system.tenant.detail.append") }}
          </lvory-but>
        </div>
      </div>
      <el-table
        class="m-bottom-5 table-header-th-top-0"
        style="width: 100% !important"
        :data="tenantInfo.relatedAreaList">
        <!--  オーナーID  -->
        <!-- <el-table-column
          class-name="col-2"
          prop="ownerExId"
          :label="$t('label.system.tenant.detail.ownerId')">
        </el-table-column> -->

        <!-- オーナー  -->
        <!-- <el-table-column
          class-name="col-2"
          prop="ownerName"
          :label="$t('label.system.tenant.detail.ownerName')">
        </el-table-column> -->

        <!--  ビルID  -->
        <el-table-column
          class-name="col-2"
          prop="buildingExId"
          :label="$t('label.system.tenant.detail.buildingExId')">
        </el-table-column>

        <!--  ビル名  -->
        <el-table-column
          class-name="col-2"
          prop="buildingName"
          :label="$t('label.system.tenant.detail.buildingName')">
        </el-table-column>

          <!--  フロア  -->
        <el-table-column
          class-name="col-2"
          prop="floorName"
          :label="$t('label.system.tenant.detail.floor')">
        </el-table-column>

        <!--  エリア  -->
        <el-table-column
          class-name="col-2"
          prop="areaName"
          :label="$t('label.system.tenant.detail.areaName')">
        </el-table-column>

        <!--  入居年月日  -->
        <el-table-column
          class-name="col-2"
          prop="moveInDate"
          :label="$t('label.system.tenant.detail.moveInDate')">
        </el-table-column>

        <!--  退去年月日  -->
        <el-table-column
          class-name="col-2"
          prop="moveOutDate"
          :label="$t('label.system.tenant.detail.moveOutDate')">
        </el-table-column>

        <!--  借入曜日  -->
        <el-table-column
          class-name="col-3"
          prop="loanDay"
          :label="$t('label.system.tenant.detail.loanDay')">
        </el-table-column>

        <!--  削除／編集  -->
        <el-table-column class-name="col-2">
          <div slot-scope="scope">
            <!--  照会バータン  -->
            <spbutton
              class="Operatingarea"
              v-auth="{ auth: '010607' }"
              @click="editRelateArea(scope.row)">
              {{ $t("label.system.tenant.detail.editTenant") }}
            </spbutton>
          </div>
        </el-table-column>

        <!--   その他操作列   -->
        <el-table-column
          class-name="col-1"
          :label="$t('label.system.building.search.result.delete')">
          <div slot-scope="scope" class="text-center">
            <sp-smart-button
              slot="reference"
              class="button-width-100 margin-5"
              @click="deleteRelateArea(scope.$index, scope.row)"
              v-auth="{ auth: '010607' }">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </div>
        </el-table-column>
      </el-table>

      <!--  配布中パック  -->
      <div
        class="form-group m-bottom-5"
        v-auth="{ auth: ['010618'] , buildingFunc: '080210' }"
      >
        <div class="word-div c-ivory01" style="width: 261px">
          配布中パック
        </div>
        <div class="edit-button-div">
          <lvory-but
            v-show="this.$authListCheck('080401', '080210') && !tenantInfo.tenantDetail.outlookSyncFlag"
            @click="packManage"
            class="Operat">
            パック管理
          </lvory-but>
          <lvory-but
            v-show="this.$authListCheck('080310', '080210') && !tenantInfo.tenantDetail.outlookSyncFlag"
            @click="PackDistributionSettings"
            class="Operat">
            パック配布設定
          </lvory-but>
        </div>
      </div>
      <el-table
        v-auth="{ auth: ['010618'] , buildingFunc: '080210' }"
        class="m-bottom-5 table-header-th-top-0"
        style="width: 100% !important"
        :data="tenantInfo.pointPackDistDetail">
        <!--  配布名称 -->
        <el-table-column
          prop="title"
          class-name="col-3"
          :label="$t('label.system.companyWalletPointDist.result.distName')">
          <template slot-scope="scope">
            <div class="title">
              {{ scope.row.title }}
            </div>
            <div class="packName">
              {{ scope.row.packName }}
            </div>
          </template>
        </el-table-column>

        <!--  配布日/回数 -->
        <el-table-column
          prop="distDate"
          class-name="col-5"
          label="配布日/回数">
          <template slot-scope="scope">
            <div class="type">
              <div class="type-text">{{ scope.row.type }}</div>
            </div>
            <div v-if="scope.row.type === '未来日'" style="position: absolute;top: 20px;left: 70px;">
              <span class="c-ivory01 fm-range-lb">{{ scope.row.distDate }}</span>
            </div>
            <div v-else style="position: absolute;top: 12px;left: 70px;">
              <div class="date-limit">
                {{ scope.row.startDate }}
                <span class="c-ivory01 fm-range-lb"> 〜 </span>
                {{ scope.row.endDate }}
              </div>
              <div class="date-limit">
                <span class="c-ivory01 fm-range-lb">次回: {{ scope.row.distDate }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <!--  配布パック数 -->
        <el-table-column
          prop="amount"
          class-name="col-2"
          label="配布パック数" />

        <!--  利用ユーザー -->
        <el-table-column
          prop="usedAmount"
          class-name="col-2"
          label="利用ユーザー" />

        <!--  未設定 -->
        <el-table-column
          class-name="col-2"
          label="未設定">
          <template slot-scope="scope">
            {{ scope.row.amount - scope.row.usedAmount}}
          </template>
        </el-table-column>

        <el-table-column
          class-name="col-2"
          align = "right">
          <div slot-scope="scope">
            <!--  owner  -->
            <spbutton
              class="Operatingarea"
              style="width: 60px;height: 32px"
              v-auth="{ auth: '080310' , func: '080210' }"
              @click="editDistributioningPointOwner(scope.row)">
              {{ $t("button.common.detail") }}
            </spbutton>

            <!--  照会バータン  -->
            <spbutton
              class="Operatingarea"
              style="width: 60px;height: 32px"
              v-auth="{ auth: '080401' , func: '080210' }"
              @click="editDistributioningPoint(scope.row)">
              {{ $t("button.common.detail") }}
            </spbutton>
          </div>
        </el-table-column>

      </el-table>


      <!--  受付担当者  -->
      <div class="form-group m-bottom-5" style="width:100%">
        <div class="word-div c-ivory01">
          {{ $t("label.system.tenant.detail.manageUser") }}
        </div>
        <div class="edit-button-div">
          <lvory-but
            v-show="this.$IsShowButFun('010608', deleteFlag, true)"
            @click="appendManageUser"
            slot="create"
            class="Operat">
            {{ $t("label.system.tenant.detail.append") }}
          </lvory-but>
        </div>
      </div>
      <el-row class="m-bottom-5">
        <el-table
          style="width: 100% !important"
          class="table-header-th-top-0"
          header-cell-class-name="sp-table-cell"
          :data="tenantInfo.uketukeUserList">
          <!--  氏名  -->
          <el-table-column
            class-name="col-2"
            prop="fullname"
            :label="$t('label.system.tenant.detail.fullname')"/>

          <!--  メールアドレス  -->
          <el-table-column
            class-name="col-2"
            prop="email"
            :label="$t('label.system.tenant.detail.email')"/>

          <!--  ロール  -->
          <el-table-column
            class-name="col-4"
            prop="roles"
            :label="$t('label.system.tenant.detail.roles')"/>

          <!--  削除  -->
          <el-table-column
            v-show="this.$IsShowButFun('010608', deleteFlag, true)"
            class-name="col-2"
            :label="$t('label.system.owner.search.result.operate')">
            <div slot-scope="scope">
              <sp-smart-button
                slot="reference"
                class="button-width-100 margin-5"
                @click="deleteManageUser(scope.$index, scope.row)">
                {{$t("button.common.data.delete")}}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </el-row>

      <hr class="delimiter" />

      <!--  管理者  -->
      <div class="color">{{ $t("label.system.tenant.detail.manage") }}</div>

      <el-row class="m-bottom-5">
        <el-table
          class="m-top-5 table-header-th-top-0"
          style="width: 100% !important"
          header-cell-class-name="sp-table-cell"
          :data="tenantInfo.manageUserList">
          <!--  氏名  -->
          <el-table-column
            class-name="col-2"
            prop="fullname"
            :label="$t('label.system.tenant.detail.fullname')"/>

          <!--  メールアドレス  -->
          <el-table-column
            class-name="col-2"
            prop="email"
            :label="$t('label.system.tenant.detail.email')"/>

          <!--  ロール  -->
          <el-table-column
            class-name="col-6"
            prop="roles"
            :label="$t('label.system.tenant.detail.roles')"/>

          <el-table-column
            v-if="tenantInfo.tenantDetail.ssoTargetFlag"
            class-name="col-6"
          >
            <template slot="header" slot-scope="scope">
              <div :id="scope.row">
                SSO対象
              </div>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.ssoTargetFlag" :disabled="!tenantInfo.tenantDetail.ssoTargetChangeEnableFlag" @change="handleCheckDetail(scope.row, scope.row.ssoTargetFlag)" />
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <hr class="delimiter" />

      <!--  利用者  -->
      <div class="color">{{ $t("label.system.tenant.detail.user") }}</div>

      <el-row>
        <el-table
          class="m-top-5 table-header-th-top-0"
          style="width: 100% !important"
          header-cell-class-name="sp-table-cell"
          :data="tenantInfo.normalUserList">
          <!--  氏名  -->
          <el-table-column
            class-name="col-2"
            prop="fullname"
            :label="$t('label.system.tenant.detail.fullname')"/>

          <!--  メールアドレス  -->
          <el-table-column
            class-name="col-2"
            prop="email"
            :label="$t('label.system.tenant.detail.email')"/>

          <!--  ロール  -->
          <el-table-column
            class-name="col-6"
            prop="roles"
            :label="$t('label.system.tenant.detail.roles')"/>

            <el-table-column
              v-if="tenantInfo.tenantDetail.ssoTargetFlag"
              class-name="col-6"
            >
            <template slot="header" slot-scope="scope">
              <div :id="scope.row">
                SSO対象
              </div>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.ssoTargetFlag" :disabled="!tenantInfo.tenantDetail.ssoTargetChangeEnableFlag" @change="handleNormalUserCheckDetail(scope.row, scope.row.ssoTargetFlag)" />
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <!--  フォーム 終了  -->

      <loading-dialog :dialogVisible="showLoading" />

      <!-- :securityDeviceList="securityDeviceList" -->
      <borrow-area-popup
        :tenantId="tenantId"
        :ownerId="tenantInfo.tenantDetail.ownerId"
        :ownerExId="tenantInfo.tenantDetail.ownerExId"
        :ownerName="tenantInfo.tenantDetail.ownerName"
        :includeDeleteDataFlag="false"
        :visible.sync="showSelectBorrowAreaDialog"
        @on-selected="handlerBorrowAreaSelected">
      </borrow-area-popup>

      <!-- 编辑借入area信息 -->
      <borrow-area-popup-edit
        :tenantId="tenantId"
        :ownerId="editBorrowArea.ownerId"
        :ownerExId="editBorrowArea.ownerExId"
        :ownerName="editBorrowArea.ownerName"
        :buildingId="editBorrowArea.buildingId"
        :buildingExId="editBorrowArea.buildingExId"
        :buildingName="editBorrowArea.buildingName"
        :floorName="editBorrowArea.floorName"
        :floorId="editBorrowArea.floorId"
        :areaId="editBorrowArea.areaId"
        :areaName="editBorrowArea.areaName"
        :startDate="editBorrowArea.startDate"
        :endDate="editBorrowArea.endDate"
        :borrowDayList="editBorrowArea.borrowDayList"
        :visible.sync="showSelectBorrowEditAreaDialog"
        :outlookSyncFlag="tenantInfo.tenantDetail.outlookSyncFlag"
        @on-selected="handlerBorrowAreaEditSelected">
      </borrow-area-popup-edit>

      <receptionist-selection-popup
        @on-selected="selectList"
        :visible.sync="showSelectReceptionDialog"
        :tenantId="tenantInfo.tenantDetail.id"
        :accountList="tenantInfo.notUketukeUserList">
      </receptionist-selection-popup>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
    </div>
    <!--  メインページ 終了  -->
  </main-layout>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import BorrowAreaPopup from "@/components/system/popup/BorrowAreaPopup";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import BorrowAreaPopupEdit from "@/components/system/popup/BorrowAreaPopupEdit";
import ReceptionistSelectionPopup from "@/components/system/popup/ReceptionistSelectionPopup";
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import SpSmartButton from "@/components/common/sp-smart-button";
import NewDesignLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard";
import Spbutton from "@/components/common/sp-smart-button-small/index";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
// import SmartOfficeAuthImage from "@/components/common/image/AuthImage";
// import moment from 'moment'
import fileDownloader from "@/utils/file-downloader";

export default {
  name: "BuildingDetail",
  components: {
    MainLayout: NewDesignLayout,
    LoadingDialog: LoadingDialog,
    BorrowAreaPopup: BorrowAreaPopup,
    BorrowAreaPopupEdit: BorrowAreaPopupEdit,
    ReceptionistSelectionPopup: ReceptionistSelectionPopup,
    // SmartOfficeAuthImage: SmartOfficeAuthImage,
    SpSmartButton,
    narrowDown,
    headTitle,
    LvoryBut,
    Menubar,
    Spbutton,
    elDialogPrompt,
  },
  data() {
    return {
      ssoBtnIsShow: true,
      resourceBtnIsShow: true,
      checkAllManageUserDetail: false,
      checkAllNormalUserDetail: false,
      isShowDeleteBut: true,
      payeSubmitData: null,
      areaSubmitData: null,
      pointSubmitData: null,
      payerIndex: null,
      payerRows: null,
      areaIndex: null,
      areaRows: null,
      pointIndex: null,
      deleteSelectFlag: null,
      msgParam: null,
      centerDialogVisibleIsShow: false,
      deleteFlag: null,
      defaultFlag : null,
      showSelectReceptionDialog: false,
      showSelectBorrowAreaDialog: false,
      showSelectBorrowEditAreaDialog: false,
      securityDeviceList: [],
      showLoading: false,
      tenantId: null,
      tenantInfo: {
        pointPackDistDetail: [{
          distId: null,
          title: null,
          packName: null,
          amount: null,
          type: null,
          distDate: null,
          usedAmount: null,
          startDate: null,
          endDate: null
        }],
        tenantDetail: {
          id: null,
          name: null,
          exId: null,
          ownerId: null,
          ownerName: null,
          ownerExId: null,
          resUserName: null,
          resUserTelNo: null,
          resUserEmail: null,
          companyAddress: null,
          companyTelNo: null,
          serviceStartDate: null,
          serviceEndDate: null,
          remarks: null,
          accountCountLimitList: [],
          img: {
            id: null,
            url: null,
          },
          ssoTargetFlag: false,
          ssoTargetChangeEnableFlag: false,
          outlookSyncFlag: false

        },
        relatedAreaList: [
          {
            ownerId: null,
            ownerExId: null,
            ownerName: null,
            tenantId: null,
            buildingId: null,
            buildingExId: null,
            buildingName: null,
            floorName:null,
            floorId:null,
            areaId: null,
            areaName: null,
            moveInDate: null,
            moveOutDate: null,
            loanDay: null,
          },
        ],
        manageUserList: [
          {
            accountId: null,
            fullname: null,
            email: null,
            roles: null,
            receptionFlag: false,
            ssoTargetFlag: false
          },
        ],
        normalUserList: [
          {
            accountId: null,
            fullname: null,
            email: null,
            roles: null,
            receptionFlag: false,
            ssoTargetFlag: false
          },
        ],
        uketukeUserList: [
          {
            accountId: null,
            fullname: null,
            email: null,
            roles: null,
            receptionFlag: false,
          },
        ],
      },
      addBorrowArea: {
        tenantId: null,
        ownerId: null,
        ownerEXId: null,
        ownerName: null,
        buildId: null,
        buildEXId: null,
        buildName: null,
        areaId: null,
        areaName: null,
        startDate: null,
        endDate: null,
        borrowDayList: [],
      },
      editBorrowArea: {
        tenantId: null,
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorName:null,
        floorId:null,
        areaId: null,
        areaName: null,
        startDate: null,
        endDate: null,
        borrowDayList: [],
      },
    };
  },
  mounted() {
    this.loadTenantInfo();
    this.getPointPackSettingInfo();
    this.showSSoBtn();
    this.showResourceBtn();
  },
  created() {
    this.$authCheck("010601");
    var breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/tenants/search",
        title: "label.router.Thetenant",
      },
      {
        path: "",
        title: "label.router.tenantDetail",
      },
    ];

    if (this.$IsTenantUser()) {
      breadcrumb.splice(2,1)
    }
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

    if (this.$IsOwnerManager() || this.$IsTenantManager()) {
      this.resourceBtnIsShow = false
    } else {
      this.resourceBtnIsShow = true
    }

    if (this.$IsTenantManager()) {
      this.ssoBtnIsShow = false
    } else {
      this.ssoBtnIsShow = true
    }

    this.tenantId = this.$route.params.tenantId;
    this.tenantInfo.relatedAreaList = [];
    this.tenantInfo.manageUserList = [];
    this.tenantInfo.allUserList = [];
    this.tenantInfo.normalUserList = [];
    this.tenantInfo.uketukeUserList = [];
    this.tenantInfo.notUketukeUserList = [];
  },
  methods: {
    showSSoBtn() {

      if (this.$IsTenantManager()) {

        SystemManageApi.getSystemOrgSso(this.tenantId)
          .then(({data}) => {

            if (data.body.ownerSSOToTenantFlag) {
              this.ssoBtnIsShow = true
            } else {
              if (data.body != null && data.body != undefined && data.body != "") {

                if (!this.$IsNullOrEmpty(data.body.policyId) || !this.$IsNullOrEmpty(data.body.azureAdUUID)) {
                  this.ssoBtnIsShow = true
                } else {
                  this.ssoBtnIsShow = false
                }
              } else {
                this.ssoBtnIsShow = false
              }
            }
          })
          .catch(() => {
            this.ssoBtnIsShow = false
          })
          .finally(() => {
            this.showLoading = false
          })

      }
    },
    showResourceBtn() {
      if (this.$IsOwnerManager() || this.$IsTenantManager()) {

          SystemManageApi.getResource(this.tenantId)
          .then(({data}) => {
            if (data.body != null && data.body != undefined && data.body != "") {
              if (data.body.googleResourceAuthInfo != null && data.body.googleResourceAuthInfo != undefined && data.body.googleResourceAuthInfo != "") {
                this.resourceBtnIsShow = true
              }

              if (data.body.outlookResourceAuthInfo != null && data.body.outlookResourceAuthInfo != undefined && data.body.outlookResourceAuthInfo != "") {
                this.resourceBtnIsShow = true
              }
            } else {
              this.resourceBtnIsShow = false
            }
          })
          .catch(() => {
            this.resourceBtnIsShow = false
          })
          .finally(() => {
            this.showLoading = false
          })

      }
    },
    isPassParam(param) {
      if (param) {
        if (this.deleteSelectFlag === "tenant") {
          SystemManageApi.deleteTenant(this.tenantId)
            .catch((error) => {
              errorCodeMsg(error, this);
            })
            .then(({ data }) => {
              if (statusErrorCodeMsg(data.statusCode, this)) {
                this.backTenantSearch();
                this.deleteTenantSuccess();
              }
            });
        }
        // if (this.deleteSelectFlag === "point") {
        //   let index = this.pointIndex;
        //   let dist_id = this.pointSubmitData;
        //   SystemManageApi.deleteWalletDistPack(dist_id);//  /point/wallet/pack/dist/{dist_id}

        //   this.tenantInfo.pointPackDistDetail.splice(index, 1);
        //   this.deletePointSuccess();
        //   this.getPointPackSettingInfo();
        // }
        if (this.deleteSelectFlag === "area") {
          let index = this.areaIndex;
          let submitData = this.areaSubmitData;
          SystemManageApi.deleteTenantAreaRelation(submitData);

          this.tenantInfo.relatedAreaList.splice(index, 1);
          this.deleteAreaSuccess();
        }
        if (this.deleteSelectFlag === "payer") {
          let submitData = this.payeSubmitData;
          SystemManageApi.deleteTenantReceptInfo(submitData)
            .catch((error) => {
              errorCodeMsg(error, this);
            })
            .then(({ data }) => {
              if (statusErrorCodeMsg(data.statusCode, this)) {
                this.setUserReceptionFlag(submitData.accountId, false);
                this.deletePayerSuccess();
              }
            });
        }
      }
    },

    getImageFile(file) {
      this.tenantCreate.imageFile = file;
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgUrl = reader.result;
        };
      } else {
        this.imgUrl = null;
      }
    },
    linkCalendarPage () {
      this.$router.push({
        name: "system-tenant-calendar",
        params: {
          tenantId: this.tenantId
        },
      })
    },
    outlookPortable(){
      this.$router.push({
        name: "system-outlook-edit",
        query: {
          pageType: '2',
          orgId: this.tenantId,
        }
      })
    },
    // テナント情報取得
    loadTenantInfo() {
      this.showLoading = true;
      SystemManageApi.detailTenant(this.tenantId) // modify by mxq
        .catch((error) => {
          errorCodeMsg(error, this);
        })
       .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.tenantInfo.tenantDetail.id = data.body.tenantDetail.id;
          this.tenantInfo.tenantDetail.name = data.body.tenantDetail.name;
          this.tenantInfo.tenantDetail.exId = data.body.tenantDetail.exId;
          this.tenantInfo.tenantDetail.ownerId = data.body.tenantDetail.ownerId;

          this.tenantInfo.tenantDetail.ssoTargetFlag = data.body.tenantDetail.ssoTargetFlag;
          this.tenantInfo.tenantDetail.ssoTargetChangeEnableFlag = data.body.tenantDetail.ssoTargetChangeEnableFlag;
          this.tenantInfo.tenantDetail.outlookSyncFlag = data.body.tenantDetail.outlookSyncFlag;

          this.tenantInfo.tenantDetail.accountCountLimitList = data.body.tenantDetail.accountCountLimitList

          this.deleteFlag = data.body.tenantDetail.deleteFlag;
          this.defaultFlag = data.body.tenantDetail.defaultFlag;
          this.tenantInfo.tenantDetail.ownerExId =
            data.body.tenantDetail.ownerExId;
          this.tenantInfo.tenantDetail.ownerName =
            data.body.tenantDetail.ownerName;
          this.tenantInfo.tenantDetail.resUserName =
            data.body.tenantDetail.resUserName;
          this.tenantInfo.tenantDetail.resUserTelNo =
            data.body.tenantDetail.resUserTelNo;
          this.tenantInfo.tenantDetail.resUserEmail =
            data.body.tenantDetail.resUserEmail;
          this.tenantInfo.tenantDetail.companyAddress =
            data.body.tenantDetail.companyAddress;
          this.tenantInfo.tenantDetail.companyTelNo =
            data.body.tenantDetail.companyTelNo;
          this.tenantInfo.tenantDetail.serviceStartDate = this.$dateTimeFormat(data.body.tenantDetail.serviceStartDate);
          if(data.body.tenantDetail.serviceEndDate) {
            this.tenantInfo.tenantDetail.serviceEndDate = this.$dateTimeFormat(data.body.tenantDetail.serviceEndDate);
          }
          this.tenantInfo.tenantDetail.remarks = data.body.tenantDetail.remarks;
          if (
            data.body.tenantDetail.portrait != null ||
            data.body.tenantDetail.portrait != undefined
          ) {
            this.tenantInfo.tenantDetail.img.id =
              data.body.tenantDetail.portrait.id;
            this.tenantInfo.tenantDetail.img.url = this.$GetImageUrl(data.body.tenantDetail.portrait.url);
          }
          this.tenantInfo.relatedAreaList = []
          if (
            data.body.relatedAreaList != null ||
            data.body.relatedAreaList != undefined
          ) {
            for (let relatedAreaList of data.body.relatedAreaList) {
              let moveOutDate = null
              if( relatedAreaList.moveOutDate == null ) {
                moveOutDate = ""
              }else {
                moveOutDate = this.$dateFormat(relatedAreaList.moveOutDate)
              }
              let loanDay = this.transDay(relatedAreaList.weekList);
              this.tenantInfo.relatedAreaList.push({
                ownerExId: relatedAreaList.ownerExId,
                ownerId: relatedAreaList.ownerId,
                ownerName: relatedAreaList.ownerName,
                buildingId: relatedAreaList.buildingId,
                buildingExId: relatedAreaList.buildingExId,
                buildingName: relatedAreaList.buildingName,
                areaName: relatedAreaList.areaName,
                areaId: relatedAreaList.areaId,
                floorName:relatedAreaList.floorName,
                floorId:relatedAreaList.floorId,
                moveInDate: this.$dateFormat(relatedAreaList.moveInDate),
                moveOutDate: moveOutDate,
                passmoveInDate: relatedAreaList.moveInDate,
                passmoveOutDate: relatedAreaList.moveOutDate,
                loanDay: loanDay,
              });
            }
          }
          this.tenantInfo.manageUserList = []
          this.checkAllManageUserDetail = true
          if (
            data.body.manageUserList != null ||
            data.body.manageUserList != undefined
          ) {
            for (let manageUser of data.body.manageUserList) {
              let role = this.codeOfValueRole(manageUser.roles);
              let obj = {
                fullname: manageUser.fullname,
                email: manageUser.email,
                roles: role,
                accountId: manageUser.accountId,
                receptionFlag: manageUser.receptionFlag,
                ssoTargetFlag: manageUser.ssoTargetFlag
              };
              if (manageUser.ssoTargetFlag === false) {
                this.checkAllManageUserDetail = false
              }
              this.tenantInfo.manageUserList.push(obj);
              this.tenantInfo.allUserList.push(obj);
            }
          }
          this.tenantInfo.normalUserList = []
          this.checkAllNormalUserDetail = true
          if (
            data.body.normalUserList != null ||
            data.body.normalUserList != undefined
          ) {
            for (let normalUser of data.body.normalUserList) {
              let role = this.codeOfValueRole(normalUser.roles);
              let obj = {
                fullname: normalUser.fullname,
                email: normalUser.email,
                roles: role,
                accountId: normalUser.accountId,
                receptionFlag: normalUser.receptionFlag,
                ssoTargetFlag: normalUser.ssoTargetFlag
              };
              if (normalUser.ssoTargetFlag === false) {
                this.checkAllNormalUserDetail = false
              }
              this.tenantInfo.allUserList.push(obj);
              this.tenantInfo.normalUserList.push(obj);
              this.tenantInfo.uketukeUserList.push(obj);
            }
          }
          this.resetUketukeInfo();

        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    //ウォレットポイント配布設定情報検索：パック
    getPointPackSettingInfo () {
      // if (this.$authCodeCheck("010618") == true && this.$checkFuncCode("080210")) {
        if(this.$authListCheck("010618","080210")) {
        this.showLoading = true;
        SystemManageApi.walletPackDistSearch({// /point/wallet/pack/dist/search
          tenantId: this.tenantId,
          hitsoryTypeList: ["02"],
          pageSize: 999,
          pageNumber: 1
        })
          .catch((error) => {
            errorCodeMsg(error, this);
          })
        .then(({ data }) => {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return;
            }
            this.tenantInfo.pointPackDistDetail = []
            for (let index of data.body.body) {
              this.tenantInfo.pointPackDistDetail.push({
                distId: index.distId,
                title: index.title,
                packName: index.packName,
                distDate: this.$dateFormat(index.distDate),
                amount: index.amount,
                usedAmount: index.usedAmount,
                type: this.distinctionCode(index.type),
                startDate: this.$dateFormat(index.startDate),
                endDate: this.$dateFormat(index.endDate)
              })
            }
          })
          .finally(() => {
            this.showLoading = false;
          });
      }
    },
    distinctionCode(code) {
      let codeName
      if(code) {
        switch(code) {
          case "01" :
            codeName = this.$t("label.point.common.now")
            break ;
          case "02" :
            codeName = this.$t("label.point.common.future")
            break ;
          case "03" :
            codeName = this.$t("label.point.common.earlyMonth")
            break ;
          case "04" :
            codeName = this.$t("label.point.common.designatedDay")
            break ;
          case "05" :
            codeName = this.$t("label.point.common.endOfMonth")
            break ;
          case "06" :
            codeName = '締日'
            break ;
          case "07" :
            codeName = '締日の翌日'
            break ;
        }
      }
      return codeName
    },
    setUserReceptionFlag(accountId, receptionFlag) {
      let userList = [];
      this.tenantInfo.allUserList.forEach((item) => {
        if (item.accountId == accountId) {
          item.receptionFlag = receptionFlag;
        }
        userList.push(item);
      });
      this.tenantInfo.allUserList = userList;
      this.resetUketukeInfo();
    },

    resetUketukeInfo() {
      const accountMap = new Map();
      for (const elem of this.tenantInfo.allUserList) {
        accountMap.set(elem.accountId, elem);
      }
      this.tenantInfo.allUserList = Array.from(accountMap.values());
      this.tenantInfo.uketukeUserList = this.tenantInfo.allUserList.filter(
        (item) => item.receptionFlag == true
      );
      this.tenantInfo.notUketukeUserList = this.tenantInfo.allUserList.filter(
        (item) => item.receptionFlag == false
      );
    },
    selectList(val) {
      this.setUserReceptionFlag(val.accountId, true);
    },

    codeOfValueRole(val) {
      if (val != null || val != undefined) {
        let role = "";
        for (let roles of val) {
          if ("0101" == roles) {
            role =
              role + this.$t("label.system.account.role.SBSystemManager") + "/";
          } else if ("0102" == roles) {
            role =
              role +
              this.$t("label.system.account.role.SBCustomerManager") +
              "/";
          } else if ("0103" == roles) {
            role =
              role +
              this.$t("label.system.account.role.SBCustomerpersonInCharge") +
              "/";
          } else if ("0201" == roles) {
            role = role + this.$t("label.system.account.role.BMStaff") + "/";
          } else if ("0202" == roles) {
            role =
              role +
              this.$t("label.system.account.role.BMCustomerPersonInCharge") +
              "/";
          } else if ("0301" == roles) {
            role =
              role + this.$t("label.system.account.role.ownerManager") + "/";
          } else if ("0302" == roles) {
            role =
              role +
              this.$t("label.system.account.role.ownerCustomerManager") +
              "/";
          } else if ("0303" == roles) {
            role =
              role +
              this.$t("label.system.account.role.ownerCustomerPersonInCharge") +
              "/";
          } else if ("0401" == roles) {
            role =
              role + this.$t("label.system.account.role.tenantManeger") + "/";
          } else if ("0402" == roles) {
            role =
              role +
              this.$t("label.system.account.role.tenantCompanyWManeger") +
              "/";
          } else if ("0403" == roles) {
            role =
              role +
              this.$t("label.system.account.role.tenantCompanyWUser") +
              "/";
          } else if ("0404" == roles) {
            role = role + this.$t("label.system.account.role.tenantUser") + "/";
          } else if ("0501" == roles) {
            role = role + this.$t("label.system.account.role.iPadUser") + "/";
          }
        }
        role = role.substring(0, role.length - 1);
        return role;
      } else {
        return "";
      }
    },
    /**
     * trans day form number to String
     */
    transDay(borrowWeek) {
      // if (null != borrowWeek && borrowWeek.length > 0) {
      //   let weekString = borrowWeek.join("，");
      //   let transString = weekString
      //     .replace(1, "月")
      //     .replace(2, "火")
      //     .replace(3, "水")
      //     .replace(4, "木")
      //     .replace(5, "金")
      //     .replace(6, "土")
      //     .replace(0, "日");
      //   console.log("transDay.end is:" + transString);
      //   return transString;
      // } else {
      //   return "";
      // }
      return this.$ShowWeekDayName(borrowWeek);
    },
    // テナント削除
    deleteTenant() {
      this.centerDialogVisibleIsShow = true;
      this.msgParam = this.$t("message.common.validation.deleteMessage", {
        field: this.$t("label.router.Thetenant"),
      });
      this.deleteSelectFlag = "tenant";
    },

    //テナント削除message
    deleteTenantSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("label.router.Thetenant"),
      }));
    },
    //配布中パック削除message
    deletePointSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: "配布中パック",
      }));
    },
    //借入エリア削除message
    deleteAreaSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("title.popup.system.borrowArea.promptInfo"),
      }));
    },
    //受付担当者削除message
    deletePayerSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("label.system.tenant.edit.manageUser"),
      }));
    },

    // テナント編集
    editTenant() {
      this.$router.push({
        name: "system-tenant-edit",
        params: {
          tenantId: this.tenantInfo.tenantDetail.id,
        },
      });
    },

    // ユーザ一エリア編集
    editUserArea() {
      this.$router.push({
        name: "system-user-area-edit",
        query: {
          tenantId: this.tenantInfo.tenantDetail.id,
          tenantName: this.tenantInfo.tenantDetail.name,
          tenantExId: this.tenantInfo.tenantDetail.exId,
        },
      });
    },

    // ユーザーデータ（CSV）取り込み
    userDataCsv() {
      SystemManageApi.accontBatchExport(this.tenantInfo.tenantDetail.id)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then((data) => {
        fileDownloader(data)
      })
      .finally(() => {
      });
    },

    //检索用addressBook
    searchAddressBook(){
      this.$router.push({name:"system-tenant-searchAddressBook"})
      this.$savePageInfo("system","tenant","M-06-24","tenant",this.tenantInfo.tenantDetail)
    },
    // ユーザ一括導入
    importUser() {
      this.$router.push({
        name: "system-tenant-userImport",
        query: {
          tenantId: this.tenantInfo.tenantDetail.id,
          tenantExId: this.tenantInfo.tenantDetail.exId,
          tenantName: this.tenantInfo.tenantDetail.name,
        },
      });
    },

    //  借入エリア情報削除
    deleteRelateArea(index, rows) {
      this.msgParam = this.$t("message.common.validation.deleteMessage", {
        field: "借入エリア",
      });
      if (this.tenantInfo.tenantDetail.outlookSyncFlag) {
        let query = {
          orgId: this.tenantInfo.tenantDetail.id,
          buildingId: rows.buildingId,
          floorId: rows.floorId,
          areaId: rows.areaId,
        }
        this.OutlookSelfCreateFacilitySearch(query);
      }
      this.areaIndex = index;
      this.areaRows = rows;
      this.areaSubmitData = {
        tenantId: this.tenantId,
        areaId: rows.areaId,
      };
      this.deleteSelectFlag = "area";
      this.centerDialogVisibleIsShow = true;

    },

    OutlookSelfCreateFacilitySearch(query) {
      SystemManageApi.OutlookSelfCreateFacilitySearch(query)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          let body = data?.body || {};
          const hasValue = Object.values(body).some(
            v => v !== null && v !== undefined && v !== ''
          );
          if (hasValue) {
            this.msgParam = this.$t("message.common.validation.WARN_AREA_DELETE_MSG");
          } else {
            this.msgParam = this.$t("message.common.validation.deleteMessage", {
              field: "借入エリア",
            });
          }
        })
        .finally(() => {
        });
    },


    //借入エリア情報編集
    editRelateArea(rowData) {
      // console.log("editRelateArea.rowData is :"+JSON.stringify(rowData));
      this.editBorrowArea.tenantId = this.tenantId;
      this.editBorrowArea.ownerId = rowData.ownerId;
      this.editBorrowArea.ownerExId = rowData.ownerExId;
      this.editBorrowArea.ownerName = rowData.ownerName;
      this.editBorrowArea.buildingId = rowData.buildingId;
      this.editBorrowArea.buildingExId = rowData.buildingExId;
      this.editBorrowArea.buildingName = rowData.buildingName;
      this.editBorrowArea.floorName = rowData.floorName;
      this.editBorrowArea.floorId = rowData.floorId;
      this.editBorrowArea.areaId = rowData.areaId;
      this.editBorrowArea.areaName = rowData.areaName;

      if ( rowData.passmoveInDate != "" || rowData.passmoveInDate != null ) {
        this.editBorrowArea.startDate = rowData.passmoveInDate
      } else {
        this.editBorrowArea.startDate = ""
      }

      if( rowData.passmoveOutDate == "" || rowData.passmoveOutDate == null ) {
        this.editBorrowArea.endDate = ""
      } else {
        this.editBorrowArea.endDate = rowData.passmoveOutDate;
      }

      // this.editBorrowArea.borrowDayList = rowData.loanDay.split('/');
      let weekDayJap = rowData.loanDay.split("，");
      let weekDays = this.formatDayToNumber(weekDayJap);
      this.editBorrowArea.borrowDayList = weekDays;
      this.showSelectBorrowEditAreaDialog = true;
      // console.log("data to child is:"+JSON.stringify(this.editBorrowArea));
    },
    editDistributioningPointOwner (row) {
      this.$router.push({
        name: "pack-distribution-history-detailed-editing",//M-08-32
        query: {
          distId: row.distId,
          pageType: '02',
          tenantId: this.tenantId,
          buildingId: this.tenantInfo.tenantDetail.accountCountLimitList[0].buildingId
        }
      })
    },
    editDistributioningPoint (row) {
      this.$router.push({
        name: "tenant-pack-distribution",//M-08-34
        params: {
          distId: row.distId
        }
      })
    },
    /**
     * 曜日类型日期转换为数字格式
     */
    formatDayToNumber(weekDayJap) {
      if (weekDayJap != null || weekDayJap != undefined) {
        let newArrayList = [];
        weekDayJap.forEach((item) => {
          if ("月" == item) {
            newArrayList.push(1);
          } else if ("火" == item) {
            newArrayList.push(2);
          } else if ("水" == item) {
            newArrayList.push(3);
          } else if ("木" == item) {
            newArrayList.push(4);
          } else if ("金" == item) {
            newArrayList.push(5);
          } else if ("土" == item) {
            newArrayList.push(6);
          } else if ("日" == item) {
            newArrayList.push(0);
          } else {
            return
          }
        });
        return newArrayList;
      } else {
        return "";
      }
    },

    // 借入エリア情報追加
    appendRelateArea() {
      this.showSelectBorrowAreaDialog = true;
    },

    handlerBorrowAreaSelected(borrowArea) {
      let loanDay = this.transDay(borrowArea.borrowWeek);
      let moveOutDate = null
      if(borrowArea.over) {
        moveOutDate = this.$dateFormat(new Date(borrowArea.over))
      }
      this.tenantInfo.relatedAreaList.push({
        tenantId: borrowArea.tenantId,
        ownerId: borrowArea.ownerId,
        ownerExId: borrowArea.ownerExId,
        ownerName: borrowArea.ownerName,
        buildingName: borrowArea.buildingName,
        buildingId: borrowArea.buildingId,
        buildingExId: borrowArea.buildingExId,
        floorName: borrowArea.floorName,
        floorId:borrowArea.floorId,
        areaName: borrowArea.areaName,
        areaId: borrowArea.areaId,
        moveInDate: this.$dateFormat(new Date(borrowArea.begin)),
        moveOutDate: moveOutDate,
        passmoveInDate: borrowArea.begin,
        passmoveOutDate: borrowArea.over,
        loanDay: loanDay,
      });
      this.tenantInfo.relatedAreaList.sort(this.sortRelatedAreaList())
    },

    sortRelatedAreaList() {
      return function(a, b) {
              if (a.buildingExId > b.buildingExId) {
                return 1
              } else if (a.buildingExId < b.buildingExId) {
                return -1
              } else {
                if (a.floorId > b.floorId) {
                  return 1
                } else if (a.floorId < b.floorId) {
                  return -1
                } else {
                  if (a.areaName > b.areaName) {
                    return 1
                  } else if (a.areaName < b.areaName) {
                    return -1
                  }
                  return 0
                }
              }
      }
    },
    /**
     * area借入编辑页面，传回值
     */
    handlerBorrowAreaEditSelected(borrowArea) {
      // 无法确定此条数据主键，重新刷新页面，popup中已经调用API
      // this.loadTenantInfo();
      // console.log(
      //   "handlerBorrowAreaEditSelected resp is:" + JSON.stringify(borrowArea)
      // );

      // 1.删除数组中修改对象
      for (let i = 0; i < this.tenantInfo.relatedAreaList.length; i++) {
        if (
          this.tenantInfo.relatedAreaList[i].ownerExId ==
            borrowArea.ownerExId &&
          this.tenantInfo.relatedAreaList[i].buildingExId ==
            borrowArea.buildingExId &&
          this.tenantInfo.relatedAreaList[i].areaId == borrowArea.areaId
        ) {
          this.tenantInfo.relatedAreaList.splice(i, 1);
          break;
        }
      }

      // 2. 修改后对象放入数组
      let loanDay = this.transDay(borrowArea.borrowDayList);
      let moveOutDate = null
      if(borrowArea.endDate) {
        moveOutDate = this.$dateFormat(new Date(borrowArea.endDate))
      }
      this.tenantInfo.relatedAreaList.push({
        tenantId: borrowArea.tenantId,
        ownerId: borrowArea.ownerId,
        ownerExId: borrowArea.ownerExId,
        ownerName: borrowArea.ownerName,
        buildingName: borrowArea.buildingName,
        buildingId: borrowArea.buildingId,
        buildingExId: borrowArea.buildingExId,
        floorName:borrowArea.floorName,
        floorId:borrowArea.floorId,
        areaName: borrowArea.areaName,
        areaId: borrowArea.areaId,
        moveInDate: this.$dateFormat(new Date(borrowArea.startDate)),
        moveOutDate: moveOutDate,
        passmoveInDate: borrowArea.startDate,
        passmoveOutDate: borrowArea.endDate,
        loanDay: loanDay,
      });
      this.tenantInfo.relatedAreaList.sort(this.sortRelatedAreaList())
    },

    //  受付担当者削除
    deleteManageUser(index, rows) {
      this.payerIndex = index;
      this.payerRows = rows;
      this.payeSubmitData = {
        accountId: rows.accountId,
        tenantId: this.tenantId,
      };
      this.deleteSelectFlag = "payer";
      this.centerDialogVisibleIsShow = true;
      this.msgParam = this.$t("message.common.validation.deleteMessage", {
        field: "受付担当者",
      });
    },

    // 受付担当者追加
    appendManageUser() {
      this.showSelectReceptionDialog = true;
    },

    //テナント検索back
    backTenantSearch() {
      this.$router.push({
        name: "system-tenant-search",
      });
    },

    //ポップアッププロンプトボックス
    msgbox() {
      this.$msgbox({
        title: this.$t("app.name"),
        message: this.$t("message.system.building.detail.deleteConfirm"),
        showCancelButton: true,
        showClose: false,
        confirmButtonText: this.$t("button.common.ok"),
        cancelButtonText: this.$t("button.common.cancel"),
      });
    },

    // Googleカレンダー認証情報編集
    googleCalendarAuthEdit() {
      this.$router.push({
        name: "system-tenant-googleCalendarAuthEdit",
        params: {
          tenantId: this.tenantId
        }
      })
    },

    linkSsoDetail () {
      this.$router.push({
        name: "system-sso-detail",
        query: {
          pageType: '2',
          tenantId: this.tenantId
        }
      })
    },

    PackDistributionSettings () {
      this.$router.push({
        name: "pack-distribution",
        query: {
          pageType: '03',
          tenantId: this.tenantId,
        }
      })
    },
    packManage () {
      this.$router.push({
        name: "tenant-pack-management",
        query: {
          pageType: '03',
          tenantId: this.tenantId,
        }
      })
    },
    resourceEdit () {
      this.$router.push({
        name: "system-resource-edit",
        query: {
          pageType: '2',
          orgId: this.tenantId
        }
      })
    },

    handleCheckDetail (info) {
      let idList = []
      idList.push(info.accountId)
      let body = {
        idList: idList,
        ssoTargetFlag: info.ssoTargetFlag
      }
      this.updatedApi(body)
    },

    handleCheckAllDetail () {
      let idList = []
      this.tenantInfo.manageUserList.forEach((info) => {
        info.ssoTargetFlag = this.checkAllManageUserDetail
        idList.push(info.accountId)
      })
      let body = {
        idList: idList,
        ssoTargetFlag: this.checkAllManageUserDetail
      }
      this.updatedApi(body)
    },

    handleNormalUserCheckDetail (info) {
      let idList = []
      idList.push(info.accountId)
      let body = {
        idList: idList,
        ssoTargetFlag: info.ssoTargetFlag
      }
      this.updatedApi(body)
    },

    handleNormalUserCheckAllDetail () {
      let idList = []
      this.tenantInfo.normalUserList.forEach((info) => {
        info.ssoTargetFlag = this.checkAllNormalUserDetail
        idList.push(info.accountId)
      })
      let body = {
        idList: idList,
        ssoTargetFlag: this.checkAllNormalUserDetail
      }
      this.updatedApi(body)
    },

    updatedApi (body) {
      this.showLoading = true
      SystemManageApi.putSystemAccountSso(this.tenantId, body)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          this.loadTenantInfo()
          this.$messageIotSuccess(this.$t("message.common.updateSuccess",{
            field: 'SSO対象'
          }))
        }).finally(()=>{
          this.showLoading = false
        })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
::v-deep .el-table .cell {
  padding: 10px !important;
  .my-button {
    margin-left: 6px;
  }
}
.row-main {
  .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}

.form-group {
  font-size: 20px;
  .lvory-but-left {
    margin-left: 100px;
  }
  .lvory-but-left-130 {
    margin-left: 200px;
  }
}

.body {
  .color {
    color: #525250;
    font-size: 20px;
    font-weight: 100;
  }
  .el-form-main {
    .margin-left {
      margin-left: 200px;
    }
    .div-size {
      width: 240px;
    }
    .buttom-size {
      width: 256px;
      margin-bottom: 20px;
    }
    .buttom-margin-top {
      margin-top: 10px;
    }
    .img-positions {
      margin-top: 30px;
      margin-right: 200px;
    }
    .image-size {
      width: 256px;
      height: 256px;
    }
    .image-top {
      margin-top: 10px;
    }
  }
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: transparent;
}
::v-deep .Operatingarea {
  .my-button {
    margin-left: 5px;
    width: 100% !important;
  }
}

.word-div {
  width: 200px;
}

.button-margin {
  ::v-deep .my-button + .my-button {
    margin-left: 0px !important;
  }
}

.margin-5 {
  margin: 5px !important;
}
/* No.129 */
.my-top-class{
  position: relative;
  bottom:30px;
}
::v-deep .body .el-form-main .buttom-margin-top{
  position: relative;
  bottom: 60px
}
.hr{
    height: 1px;
    width: 100%;
    background-color: #D1D1CD;
    margin-top: 40px;
    margin-bottom: 40px;
}
::v-deep .el-form-item--small.el-form-item{
  margin-bottom: 40px !important;
}

.left-div-type {
  width: 574px;
}

.right-div-type {
  width: 383px;
}

.display-line-box {
  display: flex;
  align-items: flex-start;
}

.margin-top-0 {
  margin-top: 0px !important;
}

.form-group-start {
  display: flex;
  align-items: flex-start;
}

.width-134 {
  width: 134px;
}

.title {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
}
.packName {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
}
.type {
  width: 44px;
  height: 19px;
  border-radius: 4px 0px 0px 0px;
  background-color: #DCE5E6;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  .type-text {
    height: 11px;
    font-family: Hiragino Kaku Gothic ProN;
    font-size: 11px;
    font-weight: 300;
    line-height: 11px;
    text-align: left;
    color: #858582;
  }
}
.date-limit {
  width: 267px;
  height: 18px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
}
</style>
